<template>
  <div class="row">
    <div class="col-8 offset-2 div-plans">
      <legend>{{ translate.credits.PlansTitle }}</legend>

      <span class="cupom" v-show="couponDiscont"
        >{{ translate.PromotionSpecial }} - {{ couponDiscont }}% {{ translate.labelDiscont }}</span
      >
      <div class="list-plans px-3 mt-5">
        <div class="row align-items-center py-3 px-3 bg-gray">
          <div class="col-4 offset-1">
            <span class="plan-value"> {{ translate.credits.price }} </span>
          </div>
          <div class="col-7">
            <div class="row d-flex align-items-center justify-content-center">
              <div class="col-lg-6 col-6 d-w ps-5">
                <span class="plan-name"> {{ translate.credits.PlansNoAssi }} </span>
                <span class="text-center recive">{{ translate.credits.recive }}</span>
              </div>
              <div class="col-lg-6 col-6 d-w pe-5">
                <span class="plan-name">{{ translate.credits.PlansAssi }}</span>
                <span class="text-center recive">{{ translate.credits.recive }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row align-items-center py-3 px-3"
          v-for="(item, index) in plans"
          :key="item.id"
          :class="{ 'bg-gray': index % 2 !== 0 }"
        >
          <div class="col-1 d-w">
            <input
              class="form-check-input"
              type="radio"
              name="flexRadioPlansCredits"
              :id="'flexRadioPlansCredits' + item.id"
              @change="handleChange(index)"
            />
          </div>
          <div class="col-4">
            <div class="row d-flex">
              <div v-if="!item.discount_value" class="col-lg-12 col-12 d-w">
                <span :class="!item.discount_value ? 'value' : 'value-cancel'"
                  >{{ locale === 'pt-br' ? 'R$' : '$' }} {{ item.value }}</span
                >
                <span class="parcelas" v-if="locale === 'pt-br'">{{
                  locale === 'pt-br' ? '(até 3x vezes sem juros)' : ''
                }}</span>
              </div>
              <div class="col-lg-6 col-12 d-w-2 px-0" v-if="item.value > 0 && item.discount_value">
                <span class="px-2 detail">{{ locale == 'pt-br' ? 'de' : 'of' }} </span>
                <span :class="item.value > 0 && !item.discount_value ? 'value' : 'value-cancel'"
                  >{{ locale === 'pt-br' ? 'R$' : '$' }} {{ item.value }}</span
                >
              </div>
              <div
                v-if="item.discount > 0 && item.discount_value"
                class="col-lg-6 col-12 d-w-2 px-0"
              >
                <span class="px-1 detail">{{ locale == 'pt-br' ? 'por' : 'only' }} </span>
                <span class="value-promotion"
                  >{{ locale === 'pt-br' ? 'R$' : '$' }} {{ item.discount_value }}</span
                >
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="row d-flex align-items-center justify-content-center">
              <div v-if="item.creditVideosAssinantes > 0" class="col-lg-5 col-5 discont-w me-2">
                <span class="discont"
                  >{{ item.creditVideosNaoAssinantes }}
                  {{ locale == 'en' ? 'credits' : 'créditos' }}</span
                >
              </div>
              <div v-if="item.creditVideosAssinantes > 0" class="col-lg-5 col-5 discont-w ms-3">
                <span class="discont"
                  >{{ item.creditVideosAssinantes }}
                  {{ locale == 'en' ? 'credits' : 'créditos' }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState } from 'pinia'
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import tradutor from 'tradutors/assine'
  import router from 'router'
  export default defineComponent({
    name: 'SubscribePlans',
    props: ['plans'],
    mounted() {
      this.selectRadiosDefault()
    },
    data() {
      return { diparobeguin: false, disparoplan: false }
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return tradutor.portugues
        } else {
          return tradutor.ingles
        }
      },
      couponDiscont: function () {
        return this.plans[0].discount && this.plans[0].discount_value ? this.plans[0].discount : 0
      }
    },
    methods: {
      decimalParaCentavos: function (numeroDecimal) {
        // Divide o número decimal por 100 para obter o valor em centavos
        var valorCentavos = Number(numeroDecimal) / 100

        // Formata o valor com duas casas decimais
        var valorFormatado = valorCentavos.toFixed(2)

        // Retorna o valor formatado como uma string
        return valorFormatado.replace('.', ',')
      },
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          }
        })
      },
      handleChange(index: number) {
        let value = this.decimalParaCentavos(0)
        if (this.plans[index])
          if (this.plans[index].discount > 0 && this.plans[index].discount_value)
            value = this.plans[index].discount_value
          else value = this.plans[index].value

        window.dataLayer = window.dataLayer || []
        if (!this.disparobegin) {
          this.disparobegin = true
          window.dataLayer.push({
            event: 'begin_checkout',
            begin_checkout: {
              tipo: 'Créditos',
              valor: value,
              acionador: this.$route.query.acionador ?? 'link direto',
              currency: this.locale === 'pt-br' ? 'BRL' : 'USD'
            }
          })
        }
        if (this.disparoplan != value) {
          window.dataLayer.push({
            event: 'select_plan',
            select_plan: {
              tipo: 'Créditos',
              valor: value,
              currency: this.locale === 'pt-br' ? 'BRL' : 'USD'
            }
          })
          this.disparoplan = value
        }
      },
      selectRadiosDefault() {
        document.getElementsByName('flexRadioPlansCredits')[0].checked = true
        this.handleChange(0)
      }
    }
  })
</script>

<style scoped lang="css">
  .form-check-input:checked[type='radio'] {
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23000'/%3e%3c/svg%3e");
  }

  .form-check-input:checked {
    background-color: #ffffff;
    border-color: #000;
  }

  .form-check-input {
    --bs-form-check-bg: #fff;
    width: 2em;
    height: 2em;
  }
  .bg-gray {
    background: #d9d9d9;
  }

  .parcelas {
    height: 10px;
    font-family: 'Roboto-Medium';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 22px;
    text-align: center;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cupom {
    height: 18px;
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 22px;
    text-align: center;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  legend {
    height: 28px;
    color: #ff6000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .detail {
    color: #b20000;
    text-align: center;
    font-weight: bold;
    font-size: larger;
  }

  .recive {
    font-family: 'Exo-2';
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    color: #000;
  }

  .black-title {
    color: #000;
    font-weight: bold;
    font-size: 26px;
    font-family: 'Exo-2';
    font-style: italic;
  }

  .subtitle span {
    font-size: 16px;
    font-weight: bold;
  }

  .discont-w {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding: 5px;

    border: 1px solid #000;
    border-radius: 20px;
    text-align: center;
    height: 33px;
  }

  .discont {
    color: #000;
    font-weight: bold;
  }

  .plan-name {
    color: #000;
    text-align: center;
    font-weight: bold;
    font-size: large;
  }

  .plan-value {
    color: #000;
    text-align: center;
    font-weight: bold;
    font-size: large;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .d-w {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .d-w-2 {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .value {
    color: #ff6000;
    text-align: center;
    font-weight: bold;
    font-size: larger;
  }
  .value-promotion {
    color: #ff6000;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }
  .value-cancel {
    color: #b20000;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    text-decoration: line-through;
  }
  .value-day {
    text-align: center;
    font-weight: bold;
    font-size: 10px;
  }

  .d-w-btn button {
    color: #fff;
  }

  .d-w-btn {
    margin-top: 10px;
    background: #ff6000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 21.6px;
    font-weight: 700;
    letter-spacing: 0;
    width: 220px;
    height: 42px;
    padding: 2px;
  }

  #warn {
    font-size: 12px;
    font-style: italic;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .div-plans {
      width: 100%;
      margin-left: 0px;
    }

    legend {
      font-size: 18px;
    }
    .plan-name {
      font-size: 10px;
    }
    .plan-value {
      font-size: 16px;
    }
    .discont {
      font-size: small;
      text-align: center;
      line-height: 15px;
    }
    .recive,
    .discont {
      font-size: 10px;
    }

    .value {
      font-size: 15px;
    }
    .value-promotion {
      font-size: 18px;
    }
  }
</style>
